import Box from '@mui/material/Box';
import logoFull from '../../../logo/logo-2026-divitta-logo-fundotransparente.png';

const LogoMain = () => (
  <Box sx={{ display: 'flex', alignItems: 'center' }}>
    <img src={logoFull} alt="DiVitta" style={{ height: 76, width: 'auto', display: 'block' }} />
  </Box>
);

export default LogoMain;
